<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.School_Application_Records')"></pageTitle>
        <myTableFilter
          @submit="handleSubmit"
          :show="{school_name: true,contact_name: true,contact_phone: true,renewal_time: true,
                    schoolStatus: true,email: true,statusText: statusText}"
        />
        <myTable ref="table" :columns="columns" requestUrl="school/list" :showPage="true">
          <template v-slot:detail="{ data }">
            <!-- <a @click="handleClick(data.row)">{{ $t("info") }}</a> -->
            <!-- <Icon
              class="cursor_p"
              @click="handleClick(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            /> -->
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="handleClick(data.row)"
            />
          </template>
          <template v-slot:status="{ data }">
            <div class="df_center">
              <div :class="statusText[data.row.status].class">{{ statusText[data.row.status].text }}</div>
            </div>
          </template>
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";

export default {
  name: "",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      statusText: {
        0: { value: "", text: "", class: "blue" },
        1: { value: "", text: "", class: "green" },
        2: { value: "", text: "", class: "grey" },
        3: { value: "", text: "", class: "grey" },
        4: { value: "", text: "", class: "grey" }
      },
      columns: [
        {
          title: this.$t("school_record.id"),
          key: "school_id",
          align: "center"
        },
        {
          title: this.$t("school_record.name"),
          key: "school_cname",
          align: "center"
        },
        {
          title: this.$t("contact_name"),
          key: "contact_name",
          align: "center"
        },
        {
          title: this.$t("contact_mobile"),
          key: "contact_mobile",
          align: "center"
        },
        {
          title: this.$t("school_record.email"),
          key: "school_email",
          align: "center"
        },
        {
          title: this.$t("school_record.renewal_time"),
          key: "renewal_time",
          align: "center"
        },
        {
          title: this.$t("school_record.status"),
          key: "status",
          align: "center",
          slot: "status"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "detail"
        }
      ],

      search: { page: 1, limit: 10 },
      list: [],
      total: 0
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading;
      this.$request.sendPost(
        "school/before-list",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          data.status.forEach((e, i) => {
            this.statusText[i].text = e.value;
            this.statusText[i].value = e.key;
          });
        }
      );
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleClick (item) {
      this.$base.linkTo("/school/record_detail", { id: item.school_id, member_id: item.member_id });
    }
  }
};
</script>

<style lang="less" scoped>
.blue {
  background-color: var(--green_four);
  color: #fff;
  border-radius: 20px;
  width: 100px;
  padding: 3px 0;
}
.green {
  background-color: var(--blue_one);
  color: #fff;
  border-radius: 20px;
  width: 100px;
  padding: 3px 0;
}
.grey {
  background-color: #ccc;
  color: #fff;
  border-radius: 20px;
  width: 100px;
  padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/school/record/record.vue